import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {UserReportConfig} from './user-report-config.model';
import {ReportBuilderService} from '../../report-builder.service';
import {SnackBarService} from '../../../../shared/services/snackbar.service';
import {GlobalSpinnerService} from '../../../../shared/components/loader-service/global-spinner.service';
@Component({
  selector: 'cm-urc-editor-dialog',
  template: `
    <span mat-dialog-title>Enter report details</span>
    <div mat-dialog-content>
      <mat-form-field floatLabel="always" class="w-100">
        <input matInput placeholder="Report config name" [(ngModel)]="config.name" (keyup.enter)="config.name && save()">
      </mat-form-field>
      <cm-list-editor placeholder="Shared with users" [list]="config.sharedUsers" (listUpdated)="config.sharedUsers = $event"></cm-list-editor>
      <p class="text-center mb-4">
	      <button mat-button color="primary"
	              class="iconed"
	              *ngIf="config.id"
	              (click)="editConfiguration()">
          <i class="far fa-cog" aria-hidden="true"></i>
          Edit configuration
	      </button>
      </p>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
      <button mat-raised-button color="primary"
              class="mr-1"
              [disabled]="!config.name"
              (click)="config.name &&save()">Save
      </button>
    </div>
  `,
})
export class UserReportConfigEditorDialogComponent {

  config: UserReportConfig;

  constructor(public dialogRef: MatDialogRef<UserReportConfigEditorDialogComponent>,
              private router: Router,
              private service: ReportBuilderService,
              private loader: GlobalSpinnerService,
              private sbs: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.config) {
      this.config = data.config;
    } else {
      this.config = new UserReportConfig();
      this.config.config = JSON.stringify(data.request);
    }
  }

  save() {
    this.config.id ? this.updateUserConfig() : this.createUserConfig();
  }

  createUserConfig() {
    this.loader.showLoader();
    this.service.createUserConfig(this.config).subscribe(next => {
      this.sbs.success('Report config successfully saved!');
      this.dialogRef.close(true);
      this.loader.hideLoader();
    },
    () => {
      this.sbs.success('Error occurred during report saving');
      this.loader.hideLoader();
    });
  }


  updateUserConfig() {
    this.loader.showLoader();
    this.service.updateUserConfig(this.config).subscribe(next => {
      this.sbs.success('Report config successfully updated!');
      this.dialogRef.close(true);
      this.loader.hideLoader();
    },
    () => {
      this.loader.hideLoader();
      this.sbs.success('Error occurred during report saving');
    });
  }

  editConfiguration() {
    this.service.config = this.config;
    this.router.navigateByUrl('/reports/builder');
    this.dialogRef.close();
  }

}
